import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Gallery = () => {
  const data = useStaticQuery(graphql`
    {
      carlosCake: file(relativePath: { eq: "carlos/carlos_cake.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosDonuts: file(relativePath: { eq: "carlos/carlos_donuts.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosCupcakes: file(relativePath: { eq: "carlos/carlos_cupcakes.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosCupcakes2: file(
        relativePath: { eq: "carlos/carlos_cupcakes2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosCrazy: file(relativePath: { eq: "carlos/carlos_crazy.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosColorCake: file(
        relativePath: { eq: "carlos/carlos_colorcake.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosPie: file(relativePath: { eq: "carlos/carlos_pie.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      carlosCookies: file(relativePath: { eq: "carlos/carlos_cookies.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const {
    carlosCake,
    carlosDonuts,
    carlosCupcakes,
    carlosCupcakes2,
    carlosCrazy,
    carlosColorCake,
    carlosPie,
    carlosCookies,
  } = data

  console.log(data)

  return (
    <GalleryGrid>
      <Img fluid={carlosCake.childImageSharp.fluid} />
      <Img fluid={carlosDonuts.childImageSharp.fluid} />
      <Img fluid={carlosCupcakes.childImageSharp.fluid} />
      <Img fluid={carlosCupcakes2.childImageSharp.fluid} />
      <Img fluid={carlosCrazy.childImageSharp.fluid} />
      <Img fluid={carlosColorCake.childImageSharp.fluid} />
      <Img fluid={carlosPie.childImageSharp.fluid} />
      <Img fluid={carlosCookies.childImageSharp.fluid} />
    </GalleryGrid>
  )
}

export default Gallery

const GalleryGrid = styled.div`
  display: grid;
  padding: 5px;
  grid-gap: 5px;
  grid-template-columns: repeat(4, 1fr);

  picture {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      transition: transform 0.2s;
      object-fit: cover;
      /* &:hover {
        transform: scale(1.5);
      } */
    }
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`
